import React, { useContext } from 'react'

import Carousel  from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"
import {useHistory} from "react-router-dom";

import { SettingsContext } from '../contexts/index.jsx'
import { getApiUrl } from '../core/config/api.js';

const CustomCarousel = ({ images, className = '' }) => {
  const settings = useContext(SettingsContext);
    const history = useHistory()
    const responsive = {
        desktop: {
            breakpoint: {max: 90000, min: 1024},
            items: 3
        },
        tablet: {
            breakpoint: {max: 1024, min: 464},
            items: 2
        },
        mobile: {
            breakpoint: {max: 464, min: 0},
            items: 1
        }
    }

    const handleImageClick = (hyperLink) => {
      hyperLink?.indexOf('https://') === 0 ? location.href = hyperLink : history.push(hyperLink + `?${settings.iframeQueryParams}`);
    }

    return (
        <div className={`carousel ${className}`}>
            <Carousel
                infinite={true}
                responsive={responsive}
                autoPlay={true}
                autoPlaySpeed={5000}
                removeArrowOnDeviceType={[ "desktop"]}
            >
                {images.map((img,i) => (
                    <div key={img[0]} className="image" onClick={()=>(img[1] ? handleImageClick(img[1]) : null)}>
                        <img src={getApiUrl(img[0])}/>
                    </div>
                ))}
            </Carousel>
        </div>
    )
}

export default CustomCarousel
